import { render } from "./GamesPage.vue?vue&type=template&id=2ceeca66&ts=true"
import script from "./GamesPage.vue?vue&type=script&lang=ts"
export * from "./GamesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__